'use strict';

var DeleteStrategyModalDirective = function DeleteStrategyModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/delete-strategy-modal.html'),
    controller: 'DeleteStrategyModalController',
    link: function link(scope, element) {
      scope.$on('strategy-listing:strategiesToRemove', function (event, selectedRows) {
        scope.populateStrategiesToRemove(selectedRows);
      });
      scope.hideDialogandRemoveStrategies = function () {
        element.parent('.modal:first').one('hidden.bs.modal', function () {
          scope.removeStrategies();
        }).modal('hide');
      };
      scope.cancelRemoveStrategies = function () {
        element.parent('.modal:first').modal('hide');
      };
      element.parent('.modal:first').on('hidden.bs.modal', function (e) {
        scope.checkboxModal = false;
      });
    }
  };
};
DeleteStrategyModalDirective.$inject = [];
module.exports = DeleteStrategyModalDirective;